import { render, staticRenderFns } from "./LocalitaDisagiate.vue?vue&type=template&id=d4765a34"
import script from "./LocalitaDisagiate.vue?vue&type=script&lang=js"
export * from "./LocalitaDisagiate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports